import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { ServiceProvider } from '../../services';

const smsSettlementService = ServiceProvider.smsSettlement;

const DEFAULT_UNIT_PRICES = {
  sms: 15,
  lms: 35,
  mms: 60,
};

const PRICE_FIELDS = [
  ['sms', 'SMS 단가'],
  ['lms', 'LMS 단가'],
  ['mms', 'MMS 단가'],
];

const SmsUnitPriceDialog = ({
  visible,
  initialPrices,
  onHide,
  onSaved,
}) => {
  const [prices, setPrices] = useState({ ...DEFAULT_UNIT_PRICES });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!visible) return;
    setPrices({
      sms: initialPrices?.sms ?? DEFAULT_UNIT_PRICES.sms,
      lms: initialPrices?.lms ?? DEFAULT_UNIT_PRICES.lms,
      mms: initialPrices?.mms ?? DEFAULT_UNIT_PRICES.mms,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleSave = async () => {
    const sms = Number(prices.sms);
    const lms = Number(prices.lms);
    const mms = Number(prices.mms);
    if ([sms, lms, mms].some((value) => !Number.isInteger(value) || value < 0)) {
      window.cerp.dialog.error(
        '단가 저장 실패',
        '단가는 0원 이상 정수여야 합니다.'
      );
      return;
    }

    setSaving(true);
    try {
      await smsSettlementService.updateUnitPrices({
        smsUnitPrice: sms,
        lmsUnitPrice: lms,
        mmsUnitPrice: mms,
      });
      window.cerp.toast.success('단가 변경', '단가를 저장했습니다.');
      onHide();
      if (onSaved) await onSaved();
    } catch (error) {
      window.cerp.dialog.error(
        '단가 저장 실패',
        error?.code
          ? `[${error.code}] ${error.message}`
          : '[서버 에러] 시스템 관리자에게 문의하세요.'
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      modal
      visible={visible}
      style={{ width: '24rem' }}
      header="문자 단가 설정"
      onHide={onHide}
      footer={
        <div className="flex justify-content-end gap-2">
          <Button
            label="취소"
            className="p-button-text"
            disabled={saving}
            onClick={onHide}
          />
          <Button
            label="저장"
            icon="pi pi-check"
            loading={saving}
            onClick={handleSave}
          />
        </div>
      }
    >
      {PRICE_FIELDS.map(([key, label]) => (
        <div key={key} className="field mb-3">
          <label htmlFor={`sms_unit_price_${key}`}>{label}</label>
          <div className="p-inputgroup">
            <InputNumber
              inputId={`sms_unit_price_${key}`}
              value={prices[key]}
              min={0}
              max={100000}
              useGrouping={false}
              className="w-full"
              inputClassName="w-full text-right"
              disabled={saving}
              onValueChange={({ value }) =>
                setPrices((ps) => ({
                  ...ps,
                  [key]: value,
                }))
              }
            />
            <span className="p-inputgroup-addon">원</span>
          </div>
        </div>
      ))}
    </Dialog>
  );
};

export default SmsUnitPriceDialog;
